import React, { useState, useEffect, useContext, useMemo, useRef } from 'react';
import { debounce } from 'lodash';
import axios, { AxiosError, all } from 'axios';
import APIService from '@shared/services/api';
import List from '@shared/component/List';
import Notify from '@shared/notify';
import TextInput from '@shared/component/TextInput';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { AuthContext } from '@shared/context/AuthContext';
import CheckValidator from '@shared/checkValidator';
import {
    ActionValues,
    PERMISSIONS_ACTIONS_LIST,
    actionsPermissionValidator,
    excludePermissions,
    hasMinRequiredPermissions,
} from '@utils/static/commonUtils';
import Lists from '@shared/component/Lists';

function ManageRoles() {
    const [errors, setError] = useState<any>({
        name: {
            required: true,
            error: true,
            message: 'Please enter role name',
            pattern: /^[A-Za-z0-9\s]*$/,
            maxLength: 50,
        },
        ids: {
            required: true,
            error: true,
            message: 'Please select permission',
        },
    });
    const listRef: any = useRef(null);
    const { setLoader } = useContext(AuthContext);
    const [permission, setPermission] = useState<any>([]);
    const [isSubmit, setIsSubmit] = useState(false);
    const [showError, setShowError] = useState(false);
    const [alluserRoles, setAllUserRoles] = useState([]);
    const [editItemId, setEditItemId] = useState(null);
    const [menuId, setMenuId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordCount, setRecordCount] = useState(0);
    const [demandId, setDemandId] = useState(null);
    const [OtherdemandId, setOtherDemandId] = useState(null);
    const [demandBidId, setDeamandBidId] = useState(null);
    const [demandOtherBidId, setDeamandOtherBidId] = useState(null);
    const [editRole, setEditRole] = useState(false);
    const [editData, setEditData] = useState<any>({
        name: null,
        permissionIds: [],
        user_permissions: [],
    });
    const [userData, setUserData] = useState<any>({
        name: null,
        ids: [],
    });
    const [showHideModel, setShowHideModel] = useState(false);
    const [allCheck, setAllCheck] = useState(false);

    const [columns, setColumns] = useState({
        id: 'ID',
        name: 'Role',
        status: 'Status',
        action: 'Action',
    });
    // On updation check the permissions for all
    useEffect(() => {
        if (permission && userData) validateAllPermissionsCheckBox();
    }, [userData]);

    const getValue = (e: any) => {
        try {
            if (editRole) {
                const data = { ...editData, ...e };
                setEditData(data);
            }
            const data = { ...userData, ...e };
            setUserData(data);
        } catch (error) {
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        if (editData?.user_permissions) {
            const permissionsSelected = editData.user_permissions;
            const previousPermissions = permissionsSelected.map(item => {
                return { id: item.id, actions: item.role_permissions.actionIds || [] };
            });
            setUserData({ name: editData.name, ids: previousPermissions });
        }
    }, [editData]);

    // Validator for global check
    const validateAllPermissionsCheckBox = () => {
        if (permission.length === userData.ids.length) {
            const valid = userData.ids.every(item => item.actions.length === 5);
            if (valid) setAllCheck(true);
            else setAllCheck(false);
        } else {
            setAllCheck(false);
        }
    };

    //Handle permission check
    const handleCheckboxChange = (permissionName: any, permissionType: any) => {
        const { ids: existingPermissions } = userData;
        const findCurrentOne = existingPermissions.find(item => item.id == permissionName);
        // console.log('====', permissionType, findCurrentOne);

        if (findCurrentOne) {
            // if exists in permissions
            if (permissionType == 'All') {
                // Handle removal of all
                const ifAllExists = findCurrentOne.actions.find(item => item === permissionType);
                if (ifAllExists) {
                    // Make actions empty when user is disabling ALL
                    const actions = [];
                    findCurrentOne.actions = actions;
                } else {
                    const actions = PERMISSIONS_ACTIONS_LIST;
                    findCurrentOne.actions = [...actions, permissionType];
                }
            } else {
                // DEFAULT CASE view/add/edit/delete
                const actions = !findCurrentOne.actions.includes(permissionType)
                    ? hasMinRequiredPermissions(findCurrentOne.actions)
                        ? [...findCurrentOne.actions, permissionType, 'All']
                        : [...findCurrentOne.actions, permissionType]
                    : findCurrentOne.actions.filter((action: any) => action !== permissionType && action !== 'All');
                findCurrentOne.actions = actions;
            }

            // Remove empty actions's element
            if (findCurrentOne.actions.length === 0) {
                const indexToRemove = existingPermissions.findIndex((item: any) => item.id === permissionName);
                if (indexToRemove !== -1) {
                    existingPermissions.splice(indexToRemove, 1);
                }
            }

            setUserData(obj => {
                const updatedObj = obj.ids.map(item => {
                    if (item.id == permissionName) {
                        return findCurrentOne;
                    }

                    return item;
                });

                errors['ids']['error'] = false;
                setError(errors);
                setShowError(false);
                return { ...obj, ids: updatedObj };
            });
        } else {
            const updatedPermissions = [
                ...existingPermissions,
                {
                    id: permissionName,
                    actions:
                        permissionType == 'All'
                            ? [...PERMISSIONS_ACTIONS_LIST, 'All']
                            : permissionType !== 'View'
                            ? ['View', permissionType]
                            : [permissionType],
                },
            ];
            console.log(updatedPermissions, 'yes');
            errors['ids']['error'] = false;
            setError(errors);
            setShowError(false);
            setUserData({ ...userData, ids: updatedPermissions });
        }
    };

    // All permissions handler
    const allCheckedHandler = e => {
        if (e.target.checked) {
            const permObj: any = [];
            for (const singlePermission of permission) {
                // if(!excludePermissions.includes(singlePermission.slug)){
                permObj.push({
                    id: singlePermission.id,
                    actions: [...PERMISSIONS_ACTIONS_LIST, 'All'],
                });
                // }
            }

            setUserData({ ...userData, ids: permObj });
        } else {
            setUserData({ ...userData, ids: [] });
        }
        // Update the state
        setAllCheck(e.target.checked);
    };

    const handelModel = (flag: boolean) => {
        try {
            setShowHideModel(flag);
            setIsSubmit(false);
            setAllCheck(false);
            if (editRole) {
                clearEditObjData();
                setEditRole(false);
                setAllCheck(false);
                setShowError(false);
            }
            clearObjData();
        } catch (error) {}
    };

    const handleEdit = (itemId: any) => {
        const itemToEdit: any = alluserRoles?.find((item: any) => item.id === itemId);
        if (itemToEdit) {
            setEditRole(true);
            handelModel(true);
            setEditItemId(itemId);
            const userPermissionIds = itemToEdit.user_permissions.map((i: any) => i.id);
            // itemToEdit['user_permissions'] = userPermissionIds;
            itemToEdit['user_permissions_ids'] = userPermissionIds;
            setEditData({ ...itemToEdit });
        } else {
            // //console.error(`Item with id ${itemId} not found.`);
        }
    };

    const searchItem = async (value: any, page: any) => {
        try {
            if (!page) {
                page = 1;
                listRef.current.resetPagination();
            }
            const data = await APIService.getAll(
                `user/search/allUser/Roles?page=${page}&order=desc&sort=createdAt&search=${value}`,
                true,
                false,
            );
            setAllUserRoles(data.data.data);
            setRecordCount(data.data.count);
        } catch (err) {
            setLoader(false);
        }
    };

    const getPermission = async () => {
        try {
            setLoader(true);
            const data = await APIService.getAll('permission/?order=desc&sort=createdAt', true, false);
            setLoader(false);
            let allPermissions = data.data.data;
            const foundObject = allPermissions.find(permission => permission.name === 'Menu/Home');
            const foundObjectTransporterDemand = allPermissions.find(
                permission => permission.name === 'Demands/Manage Demands/Transporter',
            );
            const foundObjectOtherDemand = allPermissions.find(
                permission => permission.name === 'Demands/Manage Demands/Others',
            );
            const foundObjectTransporterDemandBid = allPermissions.find(
                permission => permission.name === 'Demands/Bids/Transporter',
            );
            const foundObjectTransporterOtherDemandBid = allPermissions.find(
                permission => permission.name === 'Demands/Bids/Other',
            );
            setMenuId(foundObject.id);
            setDemandId(foundObjectTransporterDemand.id);
            setOtherDemandId(foundObjectOtherDemand.id);
            setDeamandBidId(foundObjectTransporterDemandBid.id);
            setDeamandOtherBidId(foundObjectTransporterOtherDemandBid.id);
            allPermissions = allPermissions.filter(item => !excludePermissions.includes(item.slug));
            // const foundObject = allPermissions.find(permission =>  permission.name === 'Menu/Home');
            setPermission(allPermissions);
        } catch (err) {
            setLoader(false);
        }
    };

    const getAllUserRole = async (page: any = 1) => {
        try {
            setLoader(true);
            setCurrentPage(page);
            const data = await APIService.getAll(`user/get/allUser/Roles/?page=${page}&sort=createdAt`, true, false);
            setLoader(false);
            setRecordCount(data?.data?.count || 0);
            setAllUserRoles(data.data.data);
        } catch (err) {
            setLoader(false);
        }
    };

    const checkIdExists = (array, id) => {
        return array.some(item => item.id === id);
    };

    const addRole = async () => {
        try {
            let isValid = await CheckValidator(errors, userData);
            const { ids = [], name } = userData;

            if (ids.length === 0) {
                isValid = false;
            }

            const existsdemandTransporter = checkIdExists(ids, demandId);
            const existsdemandTransporterBids = checkIdExists(ids, demandBidId);
            const existsdemandOther = checkIdExists(ids, OtherdemandId);
            const existsdemandBidsOther = checkIdExists(ids, demandOtherBidId);

            setIsSubmit(!isValid);

            if (isValid) {
                const newPermissions = [];
                const uniqueIds = new Set(ids.map(permission => permission.id));

                if (existsdemandTransporterBids && !existsdemandTransporter) {
                    newPermissions.push({ id: demandId, actions: ['View', 'Add', 'Edit', 'Delete', 'All'] });
                    uniqueIds.add(demandId);
                }
                if (existsdemandBidsOther && !existsdemandOther) {
                    newPermissions.push({ id: OtherdemandId, actions: ['View', 'Add', 'Edit', 'Delete', 'All'] });
                    uniqueIds.add(OtherdemandId);
                }

                if (!uniqueIds.has(menuId)) {
                    newPermissions.push({ id: menuId, actions: ['View', 'Add', 'Edit', 'Delete', 'All'] });
                }

                const updatedPermissions = [...ids, ...newPermissions];

                // Filter to keep only unique permissions
                const finalPermissions = updatedPermissions.filter(
                    (permission, index, self) => index === self.findIndex(p => p.id === permission.id),
                );

                const data = {
                    name,
                    permissionIds: finalPermissions,
                };

                setLoader(true);

                const updateddata = await APIService.post('user/create/role', data, true, true);
                setLoader(false);

                if (updateddata && updateddata.status === 200) {
                    getAllUserRole();
                    handelModel(false);
                    Notify('success', 'Role created successfully');
                    listRef.current.clearSearchBox();
                }
            }
        } catch (err) {
            setLoader(false);
            console.error(err);
        }
    };

    // const updateRole = async () => {
    //     try {
    //         let isValid = await CheckValidator(errors, editData);
    //         // console.log(userData?.ids?.length,'userData?.ids?.length');
    //         if (userData?.ids?.length == 1) {
    //             const check = userData?.ids.find(permission => permission.id == menuId);
    //             // console.log(check,'checkcheck')
    //             isValid = false;
    //             errors['ids']['error'] = true;
    //             setError(errors);
    //             setShowError(true);
    //             return;
    //         }
    //         if (userData?.ids?.length == 0) {
    //             isValid = false;
    //             errors['ids']['error'] = true;
    //             setError(errors);
    //             setShowError(true);
    //             return;
    //         }
    //         const existsdemandTransporter = checkIdExists(userData?.ids, demandId);
    //         const existsdemandTransporterBids = checkIdExists(userData?.ids, demandBidId);
    //         const existsdemandOther = checkIdExists(userData?.ids, OtherdemandId);
    //         const existsdemandBidsOther = checkIdExists(userData?.ids, demandOtherBidId);
    //         setIsSubmit(!isValid);
    //         if (isValid) {
    //             if (existsdemandTransporterBids && existsdemandTransporter == false) {
    //                 const demandTransporter = { id: demandId, actions: ['Add', 'Edit', 'Delete', 'All'] };
    //                 userData.ids.push(demandTransporter);
    //             }
    //             if (existsdemandBidsOther && existsdemandOther == false) {
    //                 const demandOther = { id: OtherdemandId, actions: ['Add', 'Edit', 'Delete', 'All'] };
    //                 userData.ids.push(demandOther);
    //             }
    //             const uniqueIds = new Set(userData.ids.map(permission => permission.id));
    //             const data = {
    //                 id: editItemId,
    //                 name: editData.name,
    //                 permissionIds: uniqueIds,
    //             };
    //             setLoader(true);
    //             const updateddata = await APIService.update('user/update/role', editItemId, data, true, true);
    //             setLoader(false);
    //             if (updateddata.status === 200) {
    //                 handelModel(false);
    //                 getAllUserRole();
    //                 listRef.current.clearSearchBox(true);
    //                 Notify('success', 'Role edited successfully');
    //             }
    //         }
    //     } catch (err) {
    //         setLoader(false);
    //     }
    // };

    const updateRole = async () => {
        try {
            let isValid = await CheckValidator(errors, editData);
            const { ids = [] } = userData;

            if (ids.length === 0 || (ids.length === 1 && ids[0].id === menuId)) {
                isValid = false;
                errors['ids'] = { error: true };
                setError(errors);
                setShowError(true);
                return;
            }

            const existsdemandTransporter = checkIdExists(ids, demandId);
            const existsdemandTransporterBids = checkIdExists(ids, demandBidId);
            const existsdemandOther = checkIdExists(ids, OtherdemandId);
            const existsdemandBidsOther = checkIdExists(ids, demandOtherBidId);

            setIsSubmit(!isValid);

            if (isValid) {
                const newPermissions = [];

                if (existsdemandTransporterBids && !existsdemandTransporter) {
                    newPermissions.push({ id: demandId, actions: ['View', 'Add', 'Edit', 'Delete', 'All'] });
                }
                if (existsdemandBidsOther && !existsdemandOther) {
                    newPermissions.push({ id: OtherdemandId, actions: ['View', 'Add', 'Edit', 'Delete', 'All'] });
                }

                if (!ids.some(permission => permission.id === menuId)) {
                    newPermissions.push({ id: menuId, actions: ['View', 'Add', 'Edit', 'Delete', 'All'] });
                }

                const updatedPermissions = [...ids, ...newPermissions];

                // Filter to keep only unique permissions
                const finalPermissions = updatedPermissions.filter(
                    (permission, index, self) => index === self.findIndex(p => p.id === permission.id),
                );

                const data = {
                    id: editItemId,
                    name: editData.name,
                    permissionIds: finalPermissions,
                };

                // console.log(finalPermissions, 'check userIds');
                setLoader(true);

                const updateddata = await APIService.update('user/update/role', editItemId, data, true, true);
                setLoader(false);

                if (updateddata.status === 200) {
                    handelModel(false);
                    getAllUserRole();
                    listRef.current.clearSearchBox(true);
                    Notify('success', 'Role edited successfully');
                }
            }
        } catch (err) {
            setLoader(false);
            // console.error(err);
        }
    };

    useEffect(() => {
        getAllUserRole();
        getPermission();
    }, []);

    const updateStatus = async (item: any, status: any, id: any, page: any, search: any) => {
        try {
            setLoader(true);
            const data = {
                status: status,
            };

            const updateddata = await APIService.update('user/update/roleStatus', id, data, true, true);
            setLoader(false);
            if (updateddata.status === 200) {
                Notify('success', 'Role status updated successfully');

                searchItem(search.trim(), page);
                // getAllUserRole(page);
            }
        } catch (err) {
            setLoader(false);
        }
    };

    const clearObjData = () => {
        setUserData({ name: null, ids: [] });
    };

    const clearEditObjData = () => {
        setEditData({ name: null, permissionIds: [], user_permissions: [] });
    };

    const getDeleteIds = async (ids: any) => {
        try {
            setLoader(true);
            const data = {
                ids: JSON.stringify(ids),
            };

            await APIService.post('user/delete/role', data, true, true);
            setLoader(false);
            Notify('success', 'Role deleted  successfully');
            getAllUserRole();
        } catch (error) {
            setLoader(false);
        }
    };

    const getCheckedValues = (id, type) => {
        if (userData && userData.ids) {
            const property = userData.ids.find(item => {
                return item.id == id;
            });
            return property ? property.actions.includes(type) : false;
        }
        return false;
    };

    return (
        <>
            <div className="main_body_cover">
                <div className="container dash-container">
                    <div className="dash_bread_box">
                        <ul>
                            <li>Manage Role</li>
                        </ul>
                    </div>
                    <div className="content_body_cover">
                        <Lists
                            ref={listRef}
                            headers={columns}
                            data={alluserRoles}
                            type={'add+delete'}
                            addUpdateText="Role"
                            searchItem={searchItem}
                            getById={handleEdit}
                            getDeleteIds={getDeleteIds}
                            updateStatus={updateStatus}
                            recordCount={recordCount}
                            callPagination={getAllUserRole}
                            handelModel={(e: boolean) => handelModel(e)}
                        />
                    </div>
                </div>
            </div>

            {showHideModel && (
                <Modal
                    scrollable={true}
                    show={true}
                    onHide={() => handelModel(false)}
                    backdrop="static"
                    keyboard={false}
                    size={'lg'}
                >
                    <Modal.Header closeButton onClick={() => handelModel(false)}>
                        <Modal.Title> {editRole == true ? 'Edit Role' : ' Add New Role'}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {
                            <div className="material_form_cover">
                                <form
                                    onSubmit={e => {
                                        e.preventDefault();
                                    }}
                                >
                                    <div className="field_box">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className="form-floating">
                                                    <TextInput
                                                        data={{
                                                            type: 'text',
                                                            placeholder: 'Role',
                                                            name: 'name',
                                                            id: 'floatingInput',
                                                        }}
                                                        controlName="name"
                                                        isSubmit={isSubmit}
                                                        value={editRole ? editData?.name : userData?.name}
                                                        setValue={(e: any) => getValue(e)}
                                                        errorMsg={errors?.name.message}
                                                        inputProps={errors}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="field_box">
                                        <h3>Select Permissions</h3>

                                        {errors?.ids?.required && errors?.ids?.error && isSubmit && (
                                            <div className="text-danger ft-12"> {errors?.ids.message}</div>
                                        )}
                                        {errors?.ids?.required && errors?.ids?.error && showError && (
                                            <div className="text-danger ft-12"> {errors?.ids.message}</div>
                                        )}
                                        <div className="row">
                                            <div className="col-sm-12"></div>
                                        </div>

                                        <div className="table_box_cover">
                                            <table className="dataTable">
                                                <thead>
                                                    <tr>
                                                        <th>Section</th>
                                                        <th>
                                                            <input
                                                                id="View-section"
                                                                name="section-checkbox"
                                                                type="checkbox"
                                                                value={'AllSelect'}
                                                                checked={allCheck}
                                                                onChange={allCheckedHandler}
                                                            />
                                                        </th>
                                                        <th>View </th>
                                                        <th>Add </th>
                                                        <th>Edit</th>
                                                        <th>Delete</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {permission.length > 0 &&
                                                        permission.map((item: any, index) => (
                                                            <React.Fragment key={index}>
                                                                <tr>
                                                                    <td>{item?.name}</td>
                                                                    <td>
                                                                        <input
                                                                            id={`${index}-View`}
                                                                            name={`${index}-checkbox`}
                                                                            type="checkbox"
                                                                            value="All"
                                                                            checked={
                                                                                item.name === 'Menu/Home' ||
                                                                                getCheckedValues(item.id, 'All')
                                                                            }
                                                                            onChange={() =>
                                                                                handleCheckboxChange(item.id, 'All')
                                                                            }
                                                                            disabled={item.name === 'Menu/Home'}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            id={`${index}-OnlyView`}
                                                                            name={`${index}-checkbox`}
                                                                            type="checkbox"
                                                                            value="View"
                                                                            checked={
                                                                                item.name === 'Menu/Home' ||
                                                                                getCheckedValues(item.id, 'View')
                                                                            }
                                                                            onChange={() =>
                                                                                handleCheckboxChange(item.id, 'View')
                                                                            }
                                                                            disabled={
                                                                                getCheckedValues(item.id, 'All') ||
                                                                                getCheckedValues(item.id, 'Add') ||
                                                                                getCheckedValues(item.id, 'Edit') ||
                                                                                getCheckedValues(item.id, 'Delete')
                                                                            }
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            id={`${index}-Add`}
                                                                            name={`${index}-checkbox`}
                                                                            type="checkbox"
                                                                            value="Add"
                                                                            checked={
                                                                                item.name === 'Menu/Home' ||
                                                                                getCheckedValues(item.id, 'Add')
                                                                            }
                                                                            onChange={() =>
                                                                                handleCheckboxChange(item.id, 'Add')
                                                                            }
                                                                            disabled={item.name === 'Menu/Home'}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            id={`${index}-Edit`}
                                                                            name={`${index}-checkbox`}
                                                                            type="checkbox"
                                                                            value="Edit"
                                                                            checked={
                                                                                item.name === 'Menu/Home' ||
                                                                                getCheckedValues(item.id, 'Edit')
                                                                            }
                                                                            onChange={() =>
                                                                                handleCheckboxChange(item.id, 'Edit')
                                                                            }
                                                                            disabled={item.name === 'Menu/Home'}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            id={`${index}-Delete`}
                                                                            name={`${index}-checkbox`}
                                                                            type="checkbox"
                                                                            value="Delete"
                                                                            checked={
                                                                                item.name === 'Menu/Home' ||
                                                                                getCheckedValues(item.id, 'Delete')
                                                                            }
                                                                            onChange={() =>
                                                                                handleCheckboxChange(item.id, 'Delete')
                                                                            }
                                                                            disabled={item.name === 'Menu/Home'}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            </React.Fragment>
                                                        ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            className="btn dark_btn custom_btn"
                            onClick={editRole ? updateRole : addRole}
                        >
                            {editRole ? 'Update' : 'Add'}
                        </Button>
                        <Button
                            variant="default"
                            className="btn custom_btn border_btn with_icon"
                            onClick={() => handelModel(false)}
                        >
                            Cancel
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
        </>
    );
}

export default ManageRoles;
